export default "__VITE_ASSET__CmVQkxiJ__"